<template>
  <div class="contact-popup">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="title"
      @click-left="handleClickLeft"
      @click-right="handleClickRight"
    >
      <span v-if="currentDepartment === 0" slot="left">{{$t('base.cancel')}}</span>
      <i class="iconfont icon-back" v-else slot="left"></i>
      <span v-if="currentDepartment !== 0" slot="right">{{$t('base.cancel')}}</span>
    </van-nav-bar>
    <tabs v-if="tabs.length > 1" v-model="active" :items="tabs"></tabs>
    <div v-if="isFetching" class="contact-select empty-state">
      <van-loading color="black" />
    </div>
    <div v-else-if="scenario === 'comment'" class="contact-select" @scroll.passive="onScroll">
      <div class="search-contact" @click="toggleSearch">
        <van-field
          :value="$t(`contact.search.${active}`)"
          left-icon="search"
          disabled
        />
      </div>
      <contact-list
        :loading="isFetching"
        :list="commentList[active]"
        :atAll="active === 'collab'"
        :entities="commentEntities"
        @select="toggleContact"
        @select-all="handleSelectAll"
        showCheckbox
      />
    </div>
    <div v-else class="contact-select" @scroll.passive="onScroll">
      <div v-show="active !== 'department'" class="search-contact" @click="toggleSearch">
        <van-field
          :value="$t(`contact.search.${active}`)"
          left-icon="search"
          disabled
        />
      </div>
      <user-select
        v-show="active === 'contact'"
        v-model="currentDepartment"
        :promptText="promptText"
        :userList="userList"
        :contactEntities="contactEntities"
        :department="userDepartment"
        @toggle-contact="toggleContact"
        @check-all-users="toggleAll"
        departmentVisible
      />
      <department-select
        v-show="active === 'department'"
        :baseDepartment="userDepartment"
        :selectListProp="selectListProp"
        :selectList="selectList"
        @toggle-contact="toggleContact"
      />
      <contact-list
        v-show="active === 'group'"
        :list="groupList"
        :entities="contactEntities"
        @select="toggleContact"
        showCheckbox
      />
    </div>
    <div class="contact-action">
      <span :class="['contact-selected', 'primary-color', totalCount === 0 && 'empty']" @click="toggleEditSelected"><span>{{totalCount > 0 ? `${$t('base.selected')}${selectMessage}` : $t(this.scenario=== 'comment' ? 'contact.pleaseSelectCollab' : 'contact.pleaseSelect')}}</span></span>
      <button :class="['btn', 'primary-bgcolor', !totalCount && 'disabled']" :disabled="!totalCount" @click="submitSelected">{{$t('base.complate')}}{{totalCount ? `(${totalCount})` : ''}}</button>
    </div>
    <van-popup
      class="edit-selected-view"
      v-model="showEditSelected"
      position="bottom"
      :lazy-render="false"
      :overlay="false"
    >
      <edit-selected
        v-if="showEditSelected"
        :selectListProps="selectList"
        :selectEntitiesProps="selectEntities"
        @toggle-edit-selected="toggleEditSelected"
        @delete-selected="handleRemove"
      />
    </van-popup>
    <van-popup
      class="search-view"
      v-model="showSearch"
      position="bottom"
      :lazy-render="false"
      :overlay="false"
    >
      <search-popup
        :show="showSearch"
        :placeholder="$t(`contact.search.${active}`)"
        v-model="searchText"
        @close-search="toggleSearch"
      >
        <contact-list
          :loading="searchFetching"
          :list="searchList"
          :entities="searchEntities"
          :emptyText="$t(`contact.empty.${active}`)"
          @select="selectSearchItem"
          showCheckbox
        />
      </search-popup>
    </van-popup>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import UserSelect from './UserSelect'
import DepartmentSelect from './DepartmentSelect'
import Tabs from '../utils/Tabs'
import ajax from '@/utils/ajax'
import { GET_CONTACTS, DEPARTMENT_INFO, DEPT_USER_LIST } from '@/config/api'
import config from '@/config'
import {getQueryString, encodeHTML} from '@/utils/common'
import EditSelected from './EditSelected'
import SearchPopup from '../utils/SearchPopup'
import ContactList from './ContactList'
import store from '../../store'
import {debounce} from 'lodash'

const tabMaps = {
  contact: {
    id: 'contact',
    name: i18n.t('base.staff')
  },
  department: {
    id: 'department',
    name: i18n.t('base.department')
  },
  group: {
    id: 'group',
    name: i18n.t('base.group')
  },
  collab: {
    id: 'collab',
    name: i18n.t('base.collab')
  }
}
export default {
  name: 'ContactSelect',
  i18n,
  components: {
    UserSelect,
    DepartmentSelect,
    Tabs,
    EditSelected,
    SearchPopup,
    ContactList
  },
  props: {
    selectListProp: {
      type: Array,
      default: () => []
    },
    selectEntitiesProp: {
      type: Object,
      default: () => ({})
    },
    hideDept: Boolean,
    scenario: String
  },
  data () {
    return {
      title: i18n.t(this.scenario === 'comment' ? 'contact.addCollabMemebr' : 'contact.addMemeber'),
      active: 'contact',
      tabs: [tabMaps.contact],
      selectList: [],
      selectEntities: {},
      departments: {},
      userList: [],
      groupList: [],
      departmentList: [],
      contactEntities: {},
      departmentHistory: [0],
      hideDepartment: false || this.hideDept,
      departmentVisible: config.enterprise_info.department_visible,
      showEditSelected: false,
      // users
      userDepartment: {},
      currentDepartment: 0,
      isFetching: false,
      // search
      showSearch: false,
      searchText: '',
      searchFetching: false,
      searchList: [],
      searchEntities: {},
      commentList: {
        collab: [],
        department: [],
        group: []
      },
      commentEntities: {},
      promptText: this.scenario === 'comment' ? '' : i18n.t('contact.empty.prompt')

    }
  },
  computed: {
    totalCount () {
      return this.selectList.length
    },
    selectMessage () {
      const select = []
      let selectUserLength = 0
      let selectDeptLength = 0
      let selectGroupLength = 0
      this.selectList.forEach(item_typed_id => {
        const item = this.selectEntities[item_typed_id]
        if (item.is_department) {
          selectDeptLength++
        } else if (item.is_group) {
          selectGroupLength++
        } else {
          selectUserLength++
        }
      })
      if (selectUserLength) {
        select.push(i18n.t(this.scenario === 'comment' ? 'contact.selectedCollab' : 'contact.selectedContact', [selectUserLength]))
      }
      if (selectDeptLength) {
        select.push(i18n.t('contact.selectedDepartment', [selectDeptLength]))
      }
      if (selectGroupLength) {
        select.push(i18n.t('contact.selectedGroup', [selectGroupLength]))
      }
      return select.join(i18n.t('base.splite'))
    }
  },
  watch: {
    currentDepartment (department_id) {
      if (department_id !== this.departmentHistory[this.departmentHistory.length - 2]) {
        this.departmentHistory = [...this.departmentHistory, department_id]
      } else {
        this.departmentHistory.pop()
      }
      this.loadDepartment(department_id).then(res => {
        this.userDepartment = res.department
        this.fetchUserList(this.userDepartment.id)
      })
    },
    $route (to, from) {
      this.showSearch = !!to.query.contactsearch
      this.showEditSelected = !!to.query.editselected
    },
    showSearch (show) {
      if (!show) {
        this.searchText = ''
      }
    },
    searchText (text) {
      if (text) {
        this.searchFetching = true
        this.searchList = []
        this.handleSearch(this.scenario, text)
      } else {
        this.searchList = []
      }
    }
  },
  created () {
    if (this.scenario === 'comment') {
      this.tabs = []
      this.active = 'collab'
      this.isFetching = true
      this.requestData().then(res => {
        const { contacts, departments, groups } = res
        const tabList = [{tab: 'collab', list: contacts}, {tab: 'department', list: departments}, {tab: 'group', list: groups}]
        tabList.forEach(item => {
          if (item.list.length) {
            this.tabs.push(tabMaps[item.tab])
            const {list, entities} = this.parserContact(item.list, item.tab)
            this.commentList[item.tab] = list
            this.commentEntities = {...entities, ...this.commentEntities}
            this.isFetching = false
          }
        })
      })
    } else if (!config.viewConfig.isH5HideShareLinkDownload) {
      // 暂关闭通用选人控件部门等信息展示，仅显示搜索
      if (this.departmentVisible) {
        this.tabs.push(tabMaps.department)
      }
      this.loadDepartment().then(res => {
        this.userDepartment = res.department
        this.fetchUserList(this.userDepartment.id)
      })
      this.loadGroups()
    }
  },
  methods: {
    handleClickLeft () {
      if (this.currentDepartment) {
        this.currentDepartment = this.departmentHistory[this.departmentHistory.length - 2]
      } else {
        this.handleClose()
      }
    },
    handleClickRight () {
      this.handleClose()
    },
    submitSelected () {
      this.$emit('add-contact', this.selectList, this.selectEntities)
      this.handleClose()
    },
    handleClose () {
      this.$emit('close-popup')
    },
    toggleEditSelected () {
      if (!this.showEditSelected && this.totalCount === 0) return
      this.toggleQuery('editselected')
    },
    toggleContact (item) {
      const { item_typed_id } = item
      const index = this.selectList.indexOf(item_typed_id)
      if (index >= 0) {
        this.selectList = [...this.selectList.slice(0, index), ...this.selectList.slice(index + 1)]
        delete this.selectEntities[item_typed_id]
        if (this.contactEntities[item_typed_id]) this.contactEntities[item_typed_id].checked = false
      } else {
        this.selectList.push(item_typed_id)
        this.selectEntities[item_typed_id] = item
        if (this.contactEntities[item_typed_id]) this.contactEntities[item_typed_id].checked = true
      }
    },
    toggleAll (checked) {
      let selectList = [...this.selectList]
      const entities = {...this.contactEntities}
      const selectEntities = {...this.selectEntities}
      const {invite} = this.$route.query
      this.userList.forEach(item_typed_id => {
        const item = entities[item_typed_id]
        const index = selectList.indexOf(item_typed_id)
        if (!checked && index >= 0) {
          selectList = [...selectList.slice(0, index), ...selectList.slice(index + 1)]
          delete selectEntities[item_typed_id]
          if (entities[item_typed_id]) entities[item_typed_id].checked = false
        } else if (checked && index < 0) {
          if ((invite && store.invitedCollMemberIds.indexOf(item.id) === -1) || !invite) {
            selectList.push(item_typed_id)
            selectEntities[item_typed_id] = item
            if (entities[item_typed_id]) entities[item_typed_id].checked = true
          }
        }
      })
      this.selectList = selectList
      this.contactEntities = entities
      this.selectEntities = selectEntities
    },
    fetchContactList (search_string = '', params = {}) {
      /*
        page_size
        include_group
        item_typed_id removed
        exclude_self
        include_departments
        department_id
        *search_string
      */
      const defaultParams = {
        include_groups: 1,
        include_departments: 1,
        exclude_self: 1,
        page_size: 500,
        search_string: encodeURIComponent(search_string.trim())
      }

      return ajax({
        url: `${GET_CONTACTS}?${getQueryString(Object.assign({}, defaultParams, params), false, false)}`
      })
    },
    fetchUserList (dept_id, page_number) {
      /*
        department_id
        direct
        exclude_self
        exclude_inactive
        page_size
        skip_get_count
        not_in_department_ids
      */
      const {invite} = this.$route.query
      const exclude_inactive = invite ? 0 : 1
      const params = {
        department_id: config.enterprise_info.department_visible ? dept_id : 0,
        skip_get_count: 0,
        direct: config.enterprise_info.department_visible ? 1 : 0,
        exclude_self: 1,
        exclude_inactive,
        page_size: 500,
        page_number: page_number || 1
      }
      ajax({
        url: DEPT_USER_LIST,
        data: params,
        parser: res => {
          const {list, entities} = this.parserContact(res.users, 'contact')
          if (params.page_number === 1) {
            this.userList = list
          } else {
            this.userList = this.userList.concat(list)
          }
          this.contactEntities = {...entities, ...this.contactEntities}
          this.isFetching = false
        }
      })
    },
    loadDepartment (department_id) {
      this.isFetching = true
      let url = DEPARTMENT_INFO
      // if (this.props.scenario) {
      //   url += `?scenario=${this.props.scenario}`
      // }
      return ajax({
        url,
        data: {
          department_id,
          permission_filter: false
        }
      })
    },
    loadGroups () {
      this.fetchContactList('', {include_departments: 0}).then((data) => {
        if (data && data.success) {
          // data.departments data.users
          if (data.groups.length !== 0) {
            const {list, entities} = this.parserContact(data.groups, 'group')
            this.groupList = list
            this.contactEntities = {...entities, ...this.contactEntities}
            this.tabs.push(tabMaps.group)
          }
        }
      })
    },
    handleRemove (removeIds) {
      let curruntList = [...this.selectList]
      curruntList = curruntList.filter(id => {
        const removed = removeIds.includes(id)
        if (removed && this.contactEntities[id] && !this.contactEntities[id].disabled) {
          this.contactEntities[id].checked = false
        }
        return !removed
      })
      this.selectList = curruntList
    },
    parserContact (contacts, type, fromSearch) {
      const list = []
      const entities = {}
      contacts.forEach(contact => {
        contact.item_typed_id = `${type}-${contact.id}`
        const selected = this.selectListProp.includes(contact.item_typed_id)
        const checked = this.selectList.includes(contact.item_typed_id)
        const {invite} = this.$route.query
        if (invite) {
          contact.disabled = store.invitedCollMemberIds.includes(contact.id) || selected
        } else {
          contact.disabled = selected
        }
        contact.checked = selected || checked
        contact.info = type === 'group' ? i18n.t('base.person', [contact.user_count]) : contact.login
        list.push(contact.item_typed_id)

        if (fromSearch) {
          const re = new RegExp(this.searchText, 'g')
          const replaceStr = `<span class="highlight">${encodeHTML(this.searchText)}</span>`
          contact.highlightName = contact.name.replace(re, replaceStr)
          contact.info = contact.is_group ? i18n.t('base.person', [contact.user_count]) : contact.login.replace(re, replaceStr)
        }

        entities[contact.item_typed_id] = contact
      })
      return {list, entities}
    },
    onScroll () {
    },
    toggleSearch () {
      this.toggleQuery('contactsearch')
      this.searchList = []
    },
    selectSearchItem (item) {
      this.toggleContact(item)
      this.toggleSearch()
    },
    requestData (query = '') {
      // const { id, file, hintType } = this.props
      let {typed_id, file_id} = this.$route.query
      if (file_id && !typed_id) {
        typed_id = `file_${file_id}`
      }
      const params = {
        search_string: query,
        exclude_inactive: 1,
        include_groups: 1,
        include_departments: 1,
        page_size: 500,
        include_users_without_department: true
      }

      if (this.hintType === 'review') {
        params.review_id = this.id
        params.include_groups = 0
        params.include_departments = 0
      } else {
        params.item_typed_id = typed_id
      }

      let queryArr = []
      Object.keys(params).forEach(data => queryArr.push(`${data}=${data === 'search_string' ? encodeURIComponent(params[data]) : params[data]}`))

      const url = `${GET_CONTACTS}?${queryArr.join('&')}`
      return ajax({url})
    },
    handleSelectAll () {
      this.$emit('select-all')
      this.handleClose()
    },
    handleSearch: debounce(function (type, text, params) {
      if (type === 'comment') {
        this.requestData(text).then(res => {
          this.searchFetching = false
          const { contacts, departments, groups } = res
          const tabs = {
            'collab': contacts,
            'department': departments,
            'group': groups
          }
          const item = tabs[this.active]
          const {list, entities} = this.parserContact(item, this.active, true)
          this.searchList = list
          this.searchEntities = entities
        })
      } else {
        const params = {include_departments: 0}
        if (this.active === 'group') {
          params.include_groups = 1
        }
        this.fetchContactList(text, params).then(res => {
          const key = this.active === 'contact' ? 'contacts' : 'groups'
          const {list, entities} = this.parserContact(res[key], this.active, true)
          this.searchList = list
          this.searchEntities = entities
          this.searchFetching = false
        })
      }
    }, 1000)
  }
}
</script>
<style lang="postcss">
@import 'variables';

.edit-selected-view {
  height: 100%;
  width: 100%;
}

.contact-popup {
  display: flex;
  height: 100%;
  flex-direction: column;

  & .filter-tabs {
    padding: 0 15%;
  }
}

.contact-select {
  background: var(--pageBgColor);
  flex: 1 1 auto;
  display: flex;
  overflow: hidden;
  flex-direction: column;

  &.empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.contact-action {
  box-sizing: border-box;
  border-top: 1px solid var(--sepLineColor);
  flex: 0 0 auto;
  height: 50px;
  line-height: 50px;
  display: flex;
  padding: 0 15px;

  & .contact-selected {
    flex: 1 1 auto;
    overflow-x: auto;
    overflow-y: hidden;
    padding-right: 10px;
    font-size: 14px;

    &.empty {
      color: var(--placeholderText);
    }

    & span {
      white-space: nowrap
    }
  }

  & .btn {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    align-self: center;
    color: #fff;
    border: 0
  }
}

.select-list {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  height: 100%;

  &.loading-indicator {
    color: #999;
    height: 50px;
    line-height: 40px;
    text-align: center;
    // margin-bottom: -50px;

    & .circle-icon-loading {
      display: inline-block;
      width: 14px;
      height: 14px;
      border: 2px solid #cacaca;
      border-bottom: 2px solid transparent;
      border-radius: 100%;
      animation: spin infinite 1s linear;
      vertical-align: middle;
    }

    & span {
      margin-left: 5px;
      vertical-align: middle;
    }
  }

  &.empty-state {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: center;
    text-align: center;

    & p {
      color: var(--placeholderText);
    }
  }

  & li {
    &:last-of-type {

      & .has-border-bottom {
        border: 0
      }
    }
  }

  & .select-item {
    display: flex;
    min-height: 56px;
    background-color: #fff;

    &.at-all {
      min-height: 40px;
      height: 40px;
      line-height: 40px;
      cursor: pointer;

      & .at-all-avatar {
        color: #fff;
        user-select: none;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        line-height: 30px;
        font-size: 15px;
        border-radius: 50%;
        height: 30px;
        width: 30px;
        overflow: hidden;
        margin-right: 10px;
        margin: 5px 10px 5px 15px;

      }
    }
  }

  & .van-checkbox {
    line-height: 56px;
    margin-left: 15px;
    flex: 0 0 auto;
  }

  & .thumb-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    border-radius: 36px;
    margin: 10px;
  }

  & .item-main {
    flex: 1 1 auto;
    overflow: hidden;
    box-sizing: border-box;
    height: 56px;
    padding: 10px 10px 10px 0;

    & .item-name {
      font-size: 14px;
      line-height: 20px;
      // margin-bottom: 3px;

      & .name {
        flex: 1 1 auto;
        width: 0;
      }
    }

    & .item-meta {
      color: var(--secondlyText);
      font-size: 12px;
      line-height: 16px;
    }
  }

  & .item-action {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    width: 32px;
    padding-left: 10px;
  }
}
</style>
